import React, { useContext } from "react";
import { useTranslation, Trans } from "react-i18next";
 
import NextButtonVector from "../../resources/nextButtonVector";
import { SVTUserContext } from "../../utils/SVTUserContext";
import SelfVerificationVectorOne from "../../resources/selfVerificationVectorOne";
import SelfVerificationVectorThree from "../../resources/selfVerificationVectorThree";
import SelfVerificationVectorTwo from "../../resources/selfVerificationVectorTwo";

const SelfVerificationContent = () => {
    const { setIsGuidelinesModalOpen } = useContext(SVTUserContext);
    const { t } = useTranslation(); // Initialize translation function
 
    return (
      <div className="container-bg">
        <div style={{ whiteSpace: "pre-line" }}>{t("selfVerificationToolDescription")}</div>
        <div className="info-boxes">
          <div className="info-box">
            <div className="info-box-content">
              <h6>{t("whyUseThisTool")}</h6>
              {/* <p style={{ whiteSpace: "pre-line" }}>
               {t("whyUseThisToolDescription")}
              </p>  */}
              <p style={{ whiteSpace: "pre-line" }}>
                <Trans i18nKey="whyUseThisToolDescription" components={{ strong: <strong /> }}></Trans> 
              </p>
            </div>
            <div className="self-verication-vector">
              <SelfVerificationVectorOne />
            </div>
          </div>
          <div className="info-box">
            <div className="info-box-content">
              <h6>{t("howItWorks")}</h6>
              {/* <p style={{ whiteSpace: "pre-line" }}>
                {t("howItWorksDescription")}
              </p> */}
              <p style={{ whiteSpace: "pre-line" }}>
                <Trans i18nKey="howItWorksDescription" components={{ strong: <strong /> }}></Trans> 
              </p>
            </div>
            <div className="self-verication-vector">
              <SelfVerificationVectorTwo />
            </div>
          </div>
          {/* <div className="info-box">
            <div className="info-box-content key-benefits">
              <h6>{t("keyBenefits")}</h6>
              <p style={{ whiteSpace: "pre-line" }}>
                {t("keyBenefitsDescription")}
              </p>
            </div>
            <div className="self-verication-vector">
              <SelfVerificationVectorThree />
            </div>
          </div> */}
        </div>
        <div className="page-wrapper">
          <div className="ready-next">
            <div className="col-md-12 col-sm-12">
              <span>
                <b>{t("readytobegin?")}</b> {t("clickNexttogetstarted!")}
              </span>
            </div>
            <div style={{ textAlign: "right" }}>
              <button
                className="next-button"
                onClick={() => setIsGuidelinesModalOpen(true)}
              >
                {t("next")} <NextButtonVector />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
};
 
export default SelfVerificationContent;